import React from 'react'
import { Box, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'

// COMPONENT
import FilterSelect from '../../../../../../component/select/filterSelect'
import InputTextField from '../../../../../../component/input/inputTextField'
import { ButtonContained } from '../../../../../../component/mui-custom/MuiCustom'

type Props = {}

const AddPermission: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    return (
        <form className='w-full'>
            <Box className='w-full mt-8 flex flex-col gap-5'>
                <span>
                    <FilterSelect
                        heading='ชื่อ'
                        headingNormal
                        renderValue={() => "ดาวิกา ปิติโอภาสพงศ์"}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={"1"}
                        labelId="label-fiscal-year"
                        onchange={(event) => {
                            const value = event.target.value
                        }}
                        options={[
                            <MenuItem key="1" value={1}>
                                <li>เปิดการใช้งาน</li>
                            </MenuItem>,
                            <MenuItem key="2" value={2}>
                                <li>ปิดการใช้งาน</li>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span>
                    <FilterSelect
                        heading='สำนัก/กองที่รับผิดชอบ'
                        headingNormal
                        renderValue={() => "เทศบาลนครลำปาง"}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={"1"}
                        labelId="label-fiscal-year"
                        onchange={(event) => {
                            const value = event.target.value
                        }}
                        options={[
                            <MenuItem key="1" value={1}>
                                <li>เปิดการใช้งาน</li>
                            </MenuItem>,
                            <MenuItem key="2" value={2}>
                                <li>ปิดการใช้งาน</li>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='grid grid-cols-6 gap-[10px]'>
                    <div className='col-span-6 md:col-span-3'>
                        <InputTextField
                            heading='ตำแหน่ง'
                        />
                    </div>
                    <div className='col-span-6 md:col-span-3'>
                        <FilterSelect
                            heading='บทบาท'
                            headingNormal
                            renderValue={() => "เจ้าหน้าที่ดูแลระบบ"}
                            label={t('STATUS.LABEL')}
                            selectId="select-fiscal-year"
                            value={"1"}
                            labelId="label-fiscal-year"
                            onchange={(event) => {
                                const value = event.target.value
                            }}
                            options={[
                                <MenuItem key="1" value={1}>
                                    <li>เจ้าหน้าที่ดูแลระบบ</li>
                                </MenuItem>,
                                <MenuItem key="2" value={2}>
                                    <li>เจ้าหน้าที่ดูแลระบบ2</li>
                                </MenuItem>
                            ]}
                        />
                    </div>
                </span>
                <span>
                    <InputTextField
                        value={"saraban@lampangcity.go.th"}
                        heading='E-Mail'
                    />
                </span>
                <span className='flex justify-center items-center'>
                    <ButtonContained
                        sx={{ maxWidth: 100 }}
                    >
                        {t("BUTTON.ADD")}
                    </ButtonContained>
                </span>
            </Box>
        </form>
    )
}

export default AddPermission